import {XCircleFillIcon} from '@primer/octicons-react'
import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function RebaseFailedIcon({state}: {state?: RebaseState}) {
  if (state !== RebaseState.FailedToRebase) return null

  return <XCircleFillIcon size={12} className="color-fg-danger" />
}
